import Titlebanner from "../../../globel_cmponents/title_banner";
import TourPackCreationForm from "./attractionForms/TourPackCreationForm";

const TourPackCreation = () => {
  return (
    <>
      <Titlebanner title="Tour Pack Creation" />
      <TourPackCreationForm />
    </>
  );
};

export default TourPackCreation;
